export default "__VITE_ASSET__DRx31Ya3__"